<table mat-table [dataSource]="features" style="width: 100%">
    <ng-container matColumnDef="featureName">
        <th mat-header-cell *matHeaderCellDef>Feature</th>
        <td mat-cell *matCellDef="let e;">
            {{e.featureName}}
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="usage">
        <th mat-header-cell *matHeaderCellDef>Current usage</th>
        <td mat-cell *matCellDef="let e;">{{e.usage}}</td>
        <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef>Companies</th>
        <td mat-cell *matCellDef="let e;">
            {{e.quantity}}
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="blocks">
        <th mat-header-cell *matHeaderCellDef>Additional Blocks</th>
        <td mat-cell *matCellDef="let e; let i=index">
            <span *ngIf="!edit">{{e.blockQuantity}}</span>
            <mat-form-field *ngIf="edit" >
                <button mat-button 
                        matPrefix 
                        [disabled]="i > 0"
                        (click)="reduce(i)">
                    <mat-icon>remove</mat-icon>
                </button>
                <input matInput
                        type="number"
                        [(ngModel)]="e.blockQuantity" 
                        [disabled]="true"/>
                <button mat-button 
                        matSuffix 
                        [disabled]="i > 0"
                        (click)="increase(i)">
                    <mat-icon>add</mat-icon>
                </button>
            </mat-form-field>
        </td>
        <td mat-footer-cell *matFooterCellDef>Total cost <span *ngIf="edit">({{billingPeriod}})</span></td>
    </ng-container>
    <ng-container matColumnDef="cost">
        <th mat-header-cell *matHeaderCellDef>Cost</th>
        <td mat-cell *matCellDef="let e;">
            {{e.cost | currency: 'GBP'}}
        </td>
        <td mat-footer-cell *matFooterCellDef>{{total | currency: 'GBP'}}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['featureName', 'usage', 'quantity','blocks', 'cost']" class="thead-dark"></tr>
    <tr mat-row *matRowDef="let row; columns: ['featureName', 'usage', 'quantity','blocks', 'cost']"></tr>
    <tr mat-footer-row *matFooterRowDef=" ['featureName', 'usage', 'quantity','blocks', 'cost']" style="font-weight:bold"></tr>
</table>
  